import type { ErrorMessageMode } from '@mp/http-axios'

// import { message } from 'ant-design-vue'
import { messageErrorFn } from './defineConfig'

import { msgMap } from './msgMap'

export function checkStatus(
  status: number,
  msg: string,
  errorMessageMode: ErrorMessageMode = 'message',
): void {
  let errMessage = ''

  switch (status) {
    case 400:
      errMessage = `${msg}`
      break
    // 401: Not logged in
    // Jump to the login page if not logged in, and carry the path of the current page
    // Return to the current page after successful login. This step needs to be operated on the login page.
    case 401: {
      console.error('401 error')
      // TODO: 处理 401 问题
      // const userStore = useUserStoreWithOut()
      // userStore.setToken(undefined)
      // errMessage = msg || msgMap.errMsg401
      // if (stp === SessionTimeoutProcessingEnum.PAGE_COVERAGE)
      //   userStore.setSessionTimeout(true)

      // else
      //   userStore.logout(true)

      break
    }
    case 403:
      errMessage = msgMap.errMsg403
      break
    // 404请求不存在
    case 404:
      errMessage = msgMap.errMsg404
      break
    case 405:
      errMessage = msgMap.errMsg405
      break
    case 408:
      errMessage = msgMap.errMsg408
      break
    case 500:
      errMessage = msgMap.errMsg500
      break
    case 501:
      errMessage = msgMap.errMsg501
      break
    case 502:
      errMessage = msgMap.errMsg502
      break
    case 503:
      errMessage = msgMap.errMsg503
      break
    case 504:
      errMessage = msgMap.errMsg504
      break
    case 505:
      errMessage = msgMap.errMsg505
      break
    default:
  }

  if (errMessage) {
    // if (errorMessageMode === 'modal')
    //   Modal.error({ title: msgMap.errorTip, content: errMessage })
    // else
    if (errorMessageMode === 'message')
      messageErrorFn?.(errMessage)
  }
}
